module.exports = require("@wallaby-ui/haidi/src/js/config/app_config");